import React, { Component } from 'react'
import styled from 'styled-components'
import onClickOutside from 'react-onclickoutside'
import { filter, escapeRegExp } from 'lodash'

import { translate } from '../../utils/translation'
import { palette, mediaQueries } from '../../styles/variables'
import { ArrowIcon } from '../icon/Icon'

const FilterSelectorWrapper = styled.div({
  zIndex: 'auto !important',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'visible',
})

const SelectedFilter = styled.div((props) => {
  if (props.opened) {
    return {
      borderRadius: '2px 2px 0 0',
      backgroundColor: palette.lightGray20,
      color: palette.lightGray20,
      minWidth: '200px',
      height: '39px',
      border: `1px solid${palette.lightGray50}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 10px',
      '& .arrow': {
        borderColor: palette.darkGray70,
        transform: 'translate(6px, 1px) rotate(135deg)',
        marginRight: '10px',
      },
      '& ~ div': {
        borderRadius: '0px 2px 2px 2px',
      },
    }
  }
  return {
    borderRadius: '2px',
    color: palette.lightGray20,
    minWidth: '200px',
    height: '39px',
    border: `1px solid${palette.lightGray50}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 10px',
    '> span:last-child': {
      marginRight: '10px',
    },
  }
})

const FilterWrapper = styled.div((props) => ({
  display: 'flex',
  height: '40px',
  alignItems: 'center',
  color: palette.darkGray,
  cursor: 'pointer',
  padding: '10px',
  ':hover': {
    color: palette.orange,
    '& > span': {
      borderColor: palette.orange,
    },
    '& div': {
      color: palette.orange,
    },
  },
  '& div': {
    color: props.active ? palette.orange : 'inherit',
  },
  '& > span': {
    borderColor: palette.darkGray50,
  },
}))

const FilterName = styled.div({
  fontSize: '14px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginLeft: '15px',
})

const FilterDropdown = styled.div((props) => {
  if (props.showLeft) {
    return {
      position: 'absolute',
      top: '39px',
      right: '10px',
      background: palette.white,
      borderRadius: '2px',
      overflow: 'auto',
      border: `1px solid${palette.lightGray50}`,
      zIndex: 5,
    }
  }
  return {
    position: 'absolute',
    background: palette.white,
    borderRadius: '2px',
    overflow: 'auto',
    border: `1px solid${palette.lightGray50}`,
    zIndex: 5,
    [mediaQueries.mobile]: {
      width: '100%',
    },
  }
})

const SearchInput = styled.input.attrs({
  autoComplete: 'do-not-autofill',
})({
  width: '100%',
  height: '40px',
  backgroundColor: 'transparent',
  padding: '0 20px',
  border: 'none',
  color: palette.darkGray70,
  fontSize: '15px',
  borderBottom: `1px solid ${palette.lightGray50}`,
  '::placeholder': {
    color: palette.lightGray50,
  },
})

const FilterList = styled.div({
  width: '200px',
  maxHeight: '400px',
  overflowY: 'auto',
  '& div:hover': {
    color: palette.orange,
    background: palette.lightGray20,
    cursor: 'pointer',
  },
})

const Filter = ({ onClick, active, name }) => (
  <FilterWrapper onClick={onClick} active={active}>
    <FilterName>{name}</FilterName>
  </FilterWrapper>
)

const Label = styled.span({
  fontSize: '14px',
  color: palette.darkGray50,
  fontFamily: 'geomanistregular',
  marginTop: '3px',
})

class DropDownList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      search: null,
    }

    this.openList = this.openList.bind(this)
    this.onSelect = this.onSelect.bind(this)
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  handleClickOutside = () => {
    this.setState({ isOpen: false, search: null })
  }

  onSelect(item) {
    const { onSelectItem } = this.props
    this.setState({ isOpen: false })

    if (onSelectItem) {
      onSelectItem(item)
    }
  }

  search = (event) => {
    this.setState({
      search: event.target.value,
    })
  }

  openList = () => {
    this.setState((prev) => ({
      isOpen: !prev.isOpen,
    }))
  }

  render() {
    const { isOpen, search } = this.state
    const { title, options, searchable } = this.props
    let filteredOptions = options
    if (searchable) {
      const reg = new RegExp(escapeRegExp(search) || '.*.', 'i')
      filteredOptions = filter(options, (c) => reg.test(c.label))
    }

    return (
      <FilterSelectorWrapper data-testid={title.replace(' ', '').toLowerCase()}>
        <SelectedFilter onClick={this.openList} opened={isOpen}>
          <Label>{title}</Label>
          <ArrowIcon down color={palette.darkGray50} className="arrow" />
        </SelectedFilter>
        {isOpen && (
          <FilterDropdown>
            {searchable && (
              <SearchInput
                placeholder={translate('search')}
                type="text"
                onChange={this.search}
              />
            )}
            <FilterList
              data-testid={`${title.replace(' ', '').toLowerCase()}List`}
            >
              {filteredOptions.map((c) => (
                <Filter
                  key={c.id}
                  name={c.label}
                  onClick={() => {
                    this.onSelect(c)
                  }}
                />
              ))}
            </FilterList>
          </FilterDropdown>
        )}
      </FilterSelectorWrapper>
    )
  }
}

export default onClickOutside(DropDownList)
